// extracted by mini-css-extract-plugin
export default {"menuPreferencesModal":"Gda12d1","menuPreferencesOverlayContent":"G4dbdf7"};